import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content" }
const _hoisted_3 = { class: "-mt-[14px] -mb-[15px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "block" }, " Tickets In Progress ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "mb-0 text-[20px] mt-[2px]" }, "1.35k", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "130",
              options: _ctx.ticketsInProgress,
              series: _ctx.progress
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex items-center justify-between text-sm" }, [
        _createElementVNode("span", { class: "block" }, " This Month "),
        _createElementVNode("span", { class: "leading-none text-danger-500" }, [
          _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " trending_down ")
        ])
      ], -1))
    ])
  ]))
}